import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B20FC0",
      d: "M9.253 2.923a.75.75 0 0 1 1.493 0L10.75 3v6.25H17l.076.004a.75.75 0 0 1 0 1.492L17 10.75h-6.25V17a.75.75 0 1 1-1.5 0v-6.25H3l-.077-.004a.75.75 0 0 1 0-1.492L3 9.25h6.25V3l.003-.077Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "plus"}) } }